import type { AssetVersionCommentDto } from '@api/Api';
import { WEBSITE_SNAPSHOT_ATTACHMENT_NAME } from '@config/constants';
import { isJsonString } from '@helpers/isJsonString';

export function hasUsableWebsiteSnapshot(comment: AssetVersionCommentDto) {
  return comment.attachments?.some(
    (attachment) =>
      attachment.name === WEBSITE_SNAPSHOT_ATTACHMENT_NAME && !!attachment.url
  );
}

export function hasRenderableCommentAnnotations(
  comment: AssetVersionCommentDto,
  assetType?: string
) {
  if (!comment.annotations || !isJsonString(comment.annotations)) return false;
  if (assetType === 'website' && !hasUsableWebsiteSnapshot(comment)) {
    return false;
  }
  try {
    const annotations = JSON.parse(comment.annotations);
    return Array.isArray(annotations) && annotations.length > 0;
  } catch {
    return false;
  }
}
